import axios from "axios";
import store from "./store/store";
import router from "./router";

const baseURL = process.env.VUE_APP_BACKEND_URL;

const instance = axios.create({
  baseURL: baseURL,
});

// Redirect to login on 401 (expired/invalid token)
instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      (error.response && error.response.status === 401) ||
      (error.response &&
        error.response.status === 400 &&
        error.response.data &&
        error.response.data.message === "Failed to authenticate")
    ) {
      store.commit("auth/SET_TOKEN", null);
      if (router.currentRoute.name !== "page-login") {
        router.push({ name: "page-login" });
      }
    }
    return Promise.reject(error);
  },
);

export default instance;
